<template>
  <div>
    <div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">
      {{ $t(titleData.msg1) }}
    </div>
    <div class="t-body1 t-color-bodyGrayA font-r mgt-8 pdl-24 pdr-24">
      {{ titleData.str ? $t(titleData.msg2, {str: titleData.str}) : $t(titleData.msg2) }}
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['titleData'],

  name: "titleBlock"
}
</script>